/// Menu
// import Metismenu from "metismenujs";
import React, { useReducer, useContext, useEffect, useState } from "react";
/// Scroll
import { Collapse } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { MenuList as AdminMenuList } from './Menu';
import { StudentMenuList } from "./StudentMenu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useRole } from "../../../context/UserRoleContext";
import { FaArrowRight } from "react-icons/fa";


const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const SideBar = () => {
  const tokenDetailsString = localStorage.getItem('userDetails');
  const userRoleInLocalStorage = JSON.parse(tokenDetailsString).userRole
  const [userRole, setUserRole] = useRole();
  const [selectedMenuList, setSelectedMenuList] = useState();
  const userEmail = JSON.parse(tokenDetailsString).EmailId;
  useEffect(() => {
    // if (userRoleInLocalStorage == 2) {
    //   setSelectedMenuList(StudentMenuList)
    // } else if (userRoleInLocalStorage == 1) {
    //   setSelectedMenuList(AdminMenuList)
    // }
    console.log(userEmail);
    if (userEmail == 'sharmamukul4512@gmail.com') {
      const tempList = [
        {
          title: 'Test Series Module',
          classsChange: 'mm-collapse',
          iconStyle: <i className="material-symbols-outlined">quiz</i>,
          content: [
            {
              title: 'Test Series',
              to: 'test-series',
              iconStyle: <FaArrowRight />
            },
            {
              title: 'Test Reports',
              to: 'test-reports',
              iconStyle: <FaArrowRight />
            },

          ],
        },
      ]
      setSelectedMenuList(tempList);
    } else {
      setSelectedMenuList(AdminMenuList)
    }
  }, [])
  //  let d = new Date();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }, []);

  let handleheartBlast = document.querySelector('.heart');
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  const [hideOnScroll, setHideOnScroll] = useState(true)
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll]
  )


  const handleMenuActive = status => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  }
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status })
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" })
    }
  }
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu


  useEffect(() => {
    selectedMenuList?.forEach((data) => {
      data.content?.forEach((item) => {
        if (path === item.to) {
          setState({ active: data.title })
        }
        item.content?.forEach(ele => {
          if (path === ele.to) {
            setState({ activeSubmenu: item.title, active: data.title })
          }
        })
      })
    })
  }, [path]);

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
        ? hideOnScroll > 120
          ? "fixed"
          : ""
        : ""
        }`}
    >
      <div className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {selectedMenuList?.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index} >{data.title}</li>
              )
            } else {

              return (
                <li className={`${(state.active === data.title) || (data.to === path) ? 'mm-active' : ''} `} key={index} >
                  {data.content && data.content.length > 0 ?
                    <>
                      <Link to={"#"}
                        className="has-arrow"
                        onClick={() => { handleMenuActive(data.title) }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title} </span>
                        <span className="ms-1 badge badge-xs style-1 badge-danger">{data.update}</span>
                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                          {data.content && data.content.map((data, index) => {
                            return (
                              <li key={index}
                                className={`${state.activeSubmenu === data.title ? "mm-active" : ""}`}
                              >
                                {data.content && data.content.length > 0 ?
                                  <>
                                    <Link to={data.to} className={data.hasMenu ? 'has-arrow' : ''}
                                      onClick={() => { handleSubmenuActive(data.title) }}
                                    >
                                      {data.title}
                                    </Link>
                                    <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                      <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                        {data.content && data.content.map((data, index) => {
                                          return (

                                            <li key={index}>
                                              <Link className={`${path === data.to ? "mm-active" : ""}`} to={data.to}>{data.title}</Link>
                                            </li>

                                          )
                                        })}
                                      </ul>
                                    </Collapse>
                                  </>
                                  :
                                  <Link to={data.to} className={`${data.to === path ? 'mm-active' : ''}`} >
                                    {data.iconStyle} {data.title}
                                  </Link>
                                }
                              </li>
                            )
                          })}
                        </ul>
                      </Collapse>
                    </>
                    :
                    <Link to={data.to}>
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  }

                </li>
              )
            }
          })}
        </ul>

        <div className="copyright">
          <p className="text-center"><strong>INSIGHT IAS DELHI</strong></p>
          <p className="fs-12 text-center"><span className="heart" onClick={heartBlast}></span> by Technology Xtend </p>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
